import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { BaseComponent } from '~Interfaces/basecomponent';
import { UtilisateurService } from '../../services/utilisateur.service';

/**
 * Composant pour modifier son mot de passe
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-mot-de-passe',
  templateUrl: './mot-de-passe.component.html',
  styleUrls: ['./mot-de-passe.component.scss']
})
export class MotDePasseComponent extends BaseComponent implements OnInit {
    
    token: string = '';

    login: string = '';
    password: string = '';
    password2: string = '';

    chargementEnCours: boolean = false;
    envoyerEnCours: boolean = false;

    private tokenVerification: string = '';
    private regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/;

    /**
     * Constructeur
     * @param authentificationService
     * @param route
     * @param router
     */
    constructor(
        @Inject(UtilisateurService) private utilisateurService: UtilisateurService,
        private route: ActivatedRoute,
        private router: Router) {
        super();
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        this.chargementEnCours = true;
        // R�cup�ration du token
        let token = this.route.snapshot.queryParams['Token'];
        this.router.navigate([], {
            queryParams: {
                'Token': null
            },
            queryParamsHandling: 'merge'
        });
        let obs = this.utilisateurService.obtenirInformationsToken(token);
        return obs.toPromise().then((retour: any) => {
            this.chargementEnCours = false;
            // Si OK
            if (retour && retour.Result && retour.Result.Login && retour.Result.Token) {
                this.login = retour.Result.Login;
                this.tokenVerification = retour.Result.Token;
            }
        }, (erreur) => {
            this.chargementEnCours = false;
            console.error(erreur);
        });
    }

    /**
     * Envoyer le formulaire pour modifier le mot de passe
     */
    envoyer() {
        this.envoyerEnCours = true;
        this.utilisateurService.enregistrerMotDePasseToken(this.password, this.tokenVerification).subscribe((retour: any) => {
            this.envoyerEnCours = false;
            if (retour && retour.Result) {
                this.router.navigate(['/login']);
            }
            else {
                //TODO: message d'erreur ?
            }
        }, (erreur) => {
            this.envoyerEnCours = false;
            console.error(erreur);
        });
    }

    /**
     * V�rifier le mot de passe
     */
    motDePasseValide() {
        if (this.password) {
            if (this.regexPassword.test(this.password)) {
                return true;
            }
            return false;
        }
        return true;
    }
}
